import { Link } from 'react-router-dom'

import Form from 'react-bootstrap/Form'

import './smsOptIn.scss'

export default function SmsOptIn({
  checked,
  onChange,
  disabled = false,
  id = 'sms-opt-in',
}) {
  return (
    <Form.Group className="form-group sms-opt-in" controlId={id}>
      <Form.Check
        type="checkbox"
        id={id}
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        label={
          <span>
            I agree to receive recurring automated text messages from
            Blocktickets at the mobile number I provide, including account
            notices, ticket updates, and event offers. Consent is not a
            condition of creating an account or buying tickets. Message
            frequency varies. Message and data rates may apply. Reply STOP to
            cancel and HELP for help. See our{' '}
            <Link
              to="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link
              to="/terms-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms &amp; Conditions
            </Link>
            .
          </span>
        }
      />
    </Form.Group>
  )
}
